<template>
  <div class="test-account-confirm">
    <section class="content loginUrl">
      <div class="title">
        <span>
          {{ $t('testAccountConfirm.title') }}
        </span>
      </div>
      <ul class="login-url-list">
        <li
          v-for="(loginInfo, index) in loginInfos"
          :key="index"
        >
          {{ loginInfo.loginUrl }}
        </li>
      </ul>
    </section>
    <section class="content confirm">
      <div class="title">
        <span>
          {{ $t('testAccountConfirm.confirm') }}
        </span>
      </div>
      <el-radio-group
        class="confirm-radio"
        v-model="confirm"
      >
        <el-radio :label="true">
          {{ $t('testAccountConfirm.yes') }}
        </el-radio>
        <el-radio :label="false">
          {{ $t('testAccountConfirm.no') }}
        </el-radio>
      </el-radio-group>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TestAccountConfirm',
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      confirm: false,
      loginInfos: this.payload.loginInfos || [],
    };
  },
  methods: {
    next() {
      return {
        data: {
          confirm: this.confirm,
        },
        stage: 'TestAccountConfirm',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.test-account-confirm {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10%;
  box-sizing: border-box;

  .content {
    min-width: 300px;
    width: fit-content;
    margin: 0 auto;

    &:not(:first-child) {
      margin-top: 60px;
    }
  }

  .loginUrl {
    .title {
      font-size: 16px;
      font-weight: 600;
    }

    .login-url-list {
      list-style: auto;
    }
  }

  .confirm {
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 600;
    }

    .confirm-radio {
      align-self: center;
    }
  }
}
</style>
